// Catálogo central. Las frases completas tienen prioridad; las reglas cubren
// textos variables que llegan del API (estados, contadores y mensajes).
export const TRADUCCIONES_EN = {
  "Gestiones": "Requests",
  "Digitales": "Online",
  "GestionesDigitales": "Online Requests",
  "Mis gestiones": "My requests",
  "Regresar": "Back",
  "Regresar estado": "Return status",
  "¿Qué deseás hacer?": "What would you like to do?",
  "IMPORTANTE:": "IMPORTANT:",
  "No se encontro información, revisa tus datos ó comunicate con tu asesor !!": "No information was found. Check your information or contact your representative!",
  "Con esta platafoma puedes dar tramite a tus autorizaciones y reclamos de Gastos Medicos, dar seguimiento y consultar desde cualquier dispositivo digital (Computadora, Tablet y celular).": "With this platform you can submit and track your Medical Expense claims and authorizations from any digital device (computer, tablet, or phone).",
  "Con esta platafoma puedes dar tramite a tus autorizaciones y": "With this platform you can submit and track your authorizations and",
  "reclamos de Gastos Medicos, dar seguimiento y consultar desde": "Medical Expense claims from",
  "cualquier dispositivo digital (Computadora, Tablet y celular).": "any digital device (computer, tablet, or phone).",
  "Solo debes de dar click en el boton SIGUIENTE que se encuentra en la parte inferior izquierda de la pantalla.": "Simply click the NEXT button located at the bottom left of the screen.",
  "Solo debes de dar click en el boton SIGUIENTE que se encuentra en la": "Simply click the NEXT button located at the",
  "parte inferior izquierda de la pantalla.": "bottom left of the screen.",
  "Puede adjuntar sus documentos en cualquiera de los siguientes formatos digitales: PDF, JPG, BMP, GIF , PNG, WORD, EXCEL": "You may attach documents in any of these digital formats: PDF, JPG, BMP, GIF, PNG, WORD, or EXCEL.",
  "Puede adjuntar sus documentos en cualquiera de los siguientes": "You may attach documents in any of the following",
  "formatos digitales: PDF, JPG, BMP, GIF , PNG, WORD, EXCEL": "digital formats: PDF, JPG, BMP, GIF, PNG, WORD, or EXCEL.",
  "Cargando información, espere un momento": "Loading information, please wait",
  "Cargando informaciÃ³n, espere un momento": "Loading information, please wait",
  "Gestiona tus reclamos y autorizaciones": "Manage your claims and authorizations",
  "DPI del Titular": "Policyholder ID",
  "Fecha de Nacimiento del Titular": "Policyholder's date of birth",
  "Crear Reclamo": "Create Claim",
  "Consultar gestión": "View request",
  "Crear Autorización": "Create Authorization",
  "Creación de Reclamos": "Claim Creation",
  "Creación de Autorizaciones": "Authorization Creation",
  "Consulta de Reclamos y Autorizaciones GM": "Medical Expense Claims and Authorizations",
  "Ingresa tu DPI": "Enter your ID",
  "Ingresa tu numero de gestión": "Enter your request number",
  "Ingresar": "Sign in",
  "Inicio": "Home",
  "Acciones": "Actions",
  "Importante": "Important",
  "Información": "Information",
  "Atención": "Attention",
  "Exitoso": "Successful",
  "Ingreso Exitoso": "Successfully submitted",
  "¡Completado!": "Completed!",
  "Procesando...": "Processing...",
  "Error": "Error",
  "Por favor, espera mientras procesamos la información.": "Please wait while we process the information.",
  "Se estan consultando tus datos de ingreso, por favor espera un momento, al momento de cargar cambiará de pantala": "We are retrieving your information. Please wait; the screen will update when loading is complete.",
  "Se están consultando tus datos de ingreso, por favor espera un momento, al momento de cargar cambiará de pantalla": "We are retrieving your information. Please wait; the screen will update when loading is complete.",
  "Se esta consultando tus datos": "We are retrieving your information",
  "Se está consultando tus datos": "We are retrieving your information",
  "Para continuar, debe seleccionar al menos un archivo": "To continue, select at least one file",
  "Debes completar los datos para continuar!!": "You must complete the information to continue!",
  "Debes ingresar tu # de gestion para hacer una consulta individual.": "Enter your request number to view an individual request.",
  "Debes ingresar tu # de autorizacion para validar que eres tu.": "Enter your authorization number to verify your identity.",
  "No puedes continuar con el proceso, el reclamo no existe.": "You cannot continue because the claim does not exist.",
  "Tu información ha sido confirmada, puedes proceder con tu gestión.": "Your information has been confirmed. You may continue.",
  "No fue posible digitalizar, su sesión ha finalizado, vuelva a ingresar por favor.": "The documents could not be uploaded because your session ended. Please sign in again.",
  "Se ha cargado tu información correctamente y notificado al asesor de tu reclamo": "Your information was uploaded successfully and your claim representative was notified",
  "Validando informacion General": "Validating general information",
  "No se encontro información, comunicate con tu asesor  !": "No information was found. Contact your representative!",
  "Ha ocurrido un error, por favor intentar de nuevo": "An error occurred. Please try again",
  "Esta póliza no poseé reclamos ingresados": "This policy has no submitted claims",
  "Se ha almacenado correctamente tu correo": "Your email was saved successfully",
  "No se pudo guardar": "Could not save",
  "No ha ingresado": "No information was entered",
  "Campo Vacio": "Required field",
  "Arrastra tus archivos aquí o haz clic para seleccionarlos desde tu dispositivo": "Drag your files here or click to select them from your device",
  "Drag 'n' drop some files here, or click to select files": "Drag and drop files here, or click to select them",
  "Lista de Archivos": "File List",
  "Añadir archivos": "Add files",
  "Enviar": "Send",
  "Cerrar": "Close",
  "Siguiente": "Next",
  "Anterior": "Previous",
  "Todos": "All",
  "Detalles": "Details",
  "Detalle": "Details",
  "Detalle Liquidacion": "Settlement Details",
  "DESCRIPCION": "DESCRIPTION",
  "MONTO": "AMOUNT",
  "Descripción": "Description",
  "Monto": "Amount",
  "Estado": "Status",
  "Diagnóstico": "Diagnosis",
  "Nombre Reclamo": "Claim Name",
  "Tipo / Parentesco": "Type / Relationship",
  "Tipo/Parentesco": "Type / Relationship",
  "Fecha Ingreso": "Submission Date",
  "Fecha de ingreso": "Submission date",
  "Pasos del Proceso": "Process Steps",
  "Comentarios": "Comments",
  "Reclamos Ingresados:": "Submitted Claims:",
  "Autorizaciones Ingresadas:": "Submitted Authorizations:",
  "No. Reclamo": "Claim No.",
  "Autorización": "Authorization",
  "Tipo Autorización": "Authorization Type",
  "Nombre Autori.": "Authorization Name",
  "Reclamo": "Claim",
  "Reclamos": "Claims",
  "Autorizaciones": "Authorizations",
  "Titular": "Policyholder",
  "Contacto": "Contact",
  "Email": "Email",
  "Telefono": "Phone",
  "Ingrese su enfermedad": "Enter the condition",
  "Ingrese comentarios del siniestro": "Enter comments about the incident",
  "Ingresar tu correo": "Enter your email",
  "Monto Reclamado": "Claimed Amount",
  "(-) Monto no cubierto": "(-) Non-covered Amount",
  "(-) Monto iva": "(-) Tax Amount",
  "(-) Monto deducible": "(-) Deductible Amount",
  "(-) Monto coaseguro": "(-) Coinsurance Amount",
  "(-) Monto timbres": "(-) Stamp Tax Amount",
  "Monto pagado": "Paid Amount",
  "Ingreso de autorización": "Authorization submitted",
  "Archivo de autorización": "Authorization archived",
  "Solicitud de Documentos pendientes": "Pending documents requested",
  "Documentos Añadidos a Reclamo": "Documents Added to Claim",
  "Documentos añadidos a Reclamo": "Documents Added to Claim",
  "Se han agregado nuevos Documentos a tu Reclamo": "New documents have been added to your claim",
  "Se han agregado nuevos documentos a tu reclamo": "New documents have been added to your claim",
  "Observación ingreso de liquidacion local": "Local settlement entry note",
  "Observación ingreso de liquidación local": "Local settlement entry note",
  "Reclamo abona la cantidad de Q.1,000 al deducible de la vigencia actual. Se paga consulta a Q.300.00 de acuerdo a lo usual y razonable.": "The claim applies Q1,000 to the current policy-period deductible. The consultation is reimbursed at Q300 according to usual and reasonable charges.",
  "Seguimiento": "Follow-up",
  "Estamos a la espera de la Liquidación por parte de la Cía. de Seguros.": "We are awaiting the settlement from the insurance company.",
  "Estamos a la espera de la liquidación por parte de la Cía. de Seguros.": "We are awaiting the settlement from the insurance company.",
  "Ya se dió seguimiento con el seguro, solo están a la espera de arreglar un problema administrativo para liberar la Liquidación.": "Follow-up was completed with the insurer. They are waiting for an administrative issue to be resolved before releasing the settlement.",
  "Ya se dio seguimiento con el seguro, solo están a la espera de arreglar un problema administrativo para liberar la liquidación.": "Follow-up was completed with the insurer. They are waiting for an administrative issue to be resolved before releasing the settlement.",
  "Observación ingreso de Reclamo": "Claim entry note",
  "Observación ingreso de reclamo": "Claim entry note",
  "Por favor su apoyo en dar seguimiento a mi Reclamo. Adjunto laboratorio, factura y formulario.": "Please assist with following up on my claim. Laboratory results, invoice, and form are attached.",
  "Por favor su apoyo en dar seguimiento a mi reclamo. Adjunto laboratorio, factura y formulario.": "Please assist with following up on my claim. Laboratory results, invoice, and form are attached.",
  "Prueba envio notificacion": "Notification delivery test",
  "Prueba envío notificación": "Notification delivery test",
  "Cierre": "Closure",
  "Tiene Aprobado todo": "Everything has been approved",
  "Tiene aprobado todo": "Everything has been approved",
  "Nota Autorizacion": "Authorization Note",
  "Nota Autorización": "Authorization Note",
  "Necesito que me aprueben urgente los examenes": "I urgently need the examinations to be approved",
  "Necesito que me aprueben urgente los exámenes": "I urgently need the examinations to be approved",
  "Ingreso Autorizacion": "Authorization Submitted",
  "Ingreso Autorización": "Authorization Submitted",
  "Ingreso de Autorizacion": "Authorization Submitted",
  "Ingreso de Autorización": "Authorization Submitted",
  "Examen": "Examination",
  "Exámenes": "Examinations",
  "Examenes": "Examinations",
  "Medicamento": "Medication",
  "Medicamentos": "Medications",
  "Radioterapia": "Radiotherapy",
  "Radioterapias": "Radiotherapy",
  "Quimioterapia": "Chemotherapy",
  "Quimioterapias": "Chemotherapy",
  "Terapia": "Therapy",
  "Terapias": "Therapies",
  "Hospitalizacion": "Hospitalization",
  "Hospitalización": "Hospitalization",
  "Hospitalizacion Programada": "Scheduled Hospitalization",
  "Hospitalización Programada": "Scheduled Hospitalization",
  "Hospitalizacion Emergencia": "Emergency Hospitalization",
  "Hospitalización Emergencia": "Emergency Hospitalization",
  "Dental": "Dental",
  "Reevaluacion": "Reevaluation",
  "Reevaluación": "Reevaluation",
  "Chequeo Preventivo": "Preventive Checkup",
  "Maternidad Hospitalización": "Maternity Hospitalization",
  "Ingreso por Emergencia": "Emergency Admission",
  "Consulta y Examenes": "Consultation and Examinations",
  "Consulta y Exámenes": "Consultation and Examinations",
  "Observación ingreso de autorización": "Authorization entry note",
  "Observacion ingreso de autorizacion": "Authorization entry note",
  "Observación ingreso de liquidacion dólares": "Foreign-currency settlement entry note",
  "Observación ingreso de liquidación dólares": "Foreign-currency settlement entry note",
  "Anulación de autorización": "Authorization cancelled",
  "Anulacion de autorizacion": "Authorization cancelled",
  "Rechazo total de autorización": "Authorization fully rejected",
  "Rechazo parcial de autorización": "Authorization partially rejected",
  "Anulación de Reclamo": "Claim Cancelled",
  "Anulación de reclamo": "Claim Cancelled",
  "Anulacion de Reclamo": "Claim Cancelled",
  "Anulacion de reclamo": "Claim Cancelled",
  "Anulación de Claim": "Claim Cancelled",
  "Ha finalizado el Proceso de su Reclamo, por favor revise su correo": "Your claim process has been completed. Please check your email.",
  "Ha finalizado el proceso de su reclamo, por favor revise su correo": "Your claim process has been completed. Please check your email.",
  "Ha finalizado el Process de su Claim, por favor revise su correo": "Your claim process has been completed. Please check your email.",
  "Reclamo abona deducible": "Claim Applied to Deductible",
  "Claim abona deducible": "Claim Applied to Deductible",
  "Recordatorio de documentos pendientes": "Pending documents reminder",
  "Envío de reconsideración de autorización": "Authorization reconsideration submitted",
  "Seguimiento interno de autorización": "Internal authorization follow-up",
  "Seguimiento interno del autorización": "Internal authorization follow-up",
  "Descargar Autorización": "Download Authorization",
  "Descargar Liquidación": "Download Settlement",
  "Fecha Liquidación:": "Settlement Date:",
  "Selecciona tu país": "Select your country",
  "Cerrar aviso": "Close notice",
  "Puedes cambiar tu país aquí en cualquier momento para personalizar la información que ves.": "You can change your country here at any time to personalize the information you see.",
  "Español": "Spanish",
  "Inglés": "English",
  "Idioma": "Language",
  "Selecciona tu idioma": "Select your language",
  "Servicio al Cliente": "Customer Service",
  "Nuestra Comunidad": "Our Community",
  "Newsletter": "Newsletter",
  "Cotizar": "Get a Quote",
  "Suscríbete": "Subscribe",
  "Recibe información de nuestras últimas novedades en productos y asesoria": "Receive updates about our latest products and advisory services",
  "Cabina 24/7": "24/7 Assistance",
  "Número de gestión": "Request number",
  "Crear Reclamo GM": "Create Medical Expense Claim",
  "Consulta Reclamo GM": "View Medical Expense Claim",
  "Consulta Reclamo Auto": "View Authorization"
  ,"Informacion General Asegurado": "General Insured Information"
  ,"Información General Asegurado": "General Insured Information"
  ,"Formulario de ingreso": "Request Entry Form"
  ,"Poliza:": "Policy:"
  ,"Póliza:": "Policy:"
  ,"Certificado:": "Certificate:"
  ,"Consulta:": "Request Type:"
  ,"Titular:": "Policyholder:"
  ,"Autorización de:": "Authorization for:"
  ,"Reclamo de:": "Claim for:"
  ,"Dependiente": "Dependent"
  ,"Tipo de Autorizacion:": "Authorization Type:"
  ,"Tipo de Autorización:": "Authorization Type:"
  ,"Tipo de Reclamo:": "Claim Type:"
  ,"Gastos Medicos": "Medical Expenses"
  ,"Gastos Médicos": "Medical Expenses"
  ,"Vida": "Life"
  ,"Fecha de Ocurrencia": "Date of Occurrence"
  ,"¿Presenta reclamo de este diagnóstico por primera vez?": "Is this the first claim for this diagnosis?"
  ,"Si": "Yes"
  ,"Sí": "Yes"
  ,"No": "No"
  ,"Enfermedad": "Condition"
  ,"Otra Enfermedad": "Other Condition"
  ,"Detalles de Contacto": "Contact Details"
  ,"Documentos": "Documents"
  ,"Quitar": "Remove"
  ,"Contacto:": "Contact:"
  ,"Telefono:": "Phone:"
  ,"Teléfono:": "Phone:"
  ,"El limite de tamaño de archivos no puede exceder los 5 MB.": "The total file size cannot exceed 5 MB."
  ,"El límite de tamaño de archivos no puede exceder los 5 MB.": "The total file size cannot exceed 5 MB."
  ,"Generar": "Submit"
  ,"Gestión No:": "Request No.:"
  ,"Reclamo No:": "Claim No.:"
  ,"Autorización No:": "Authorization No.:"
  ,"Asesor": "Representative"
  ,"Ver Liquidación": "View Settlement"
  ,"Liquidación de Reclamo No:": "Claim Settlement No.:"
  ,"Numero de Cheque / Transferencia:": "Check / Transfer Number:"
  ,"Número de Cheque / Transferencia:": "Check / Transfer Number:"
  ,"Dirigido a:": "Payable to:"
  ,"Observaciones Liquidacion:": "Settlement Notes:"
  ,"Mostrar Gráfica": "Show Chart"
  ,"No hay datos disponibles": "No data available"
  ,"Primera": "First"
  ,"Última": "Last"
  ,"registros": "records"
  ,"# de reclamos": "# of claims"
  ,"# de autorizaciones": "# of authorizations"
  ,"Proceso": "In Progress"
  ,"Cerrado": "Closed"
  ,"Anulado": "Cancelled"
  ,"El archivo excede el tamaño permitido de 5MB": "The file exceeds the 5 MB size limit"
  ,"El nombre del archivo es muy largo, máximo 40 caracteres": "The file name is too long; the maximum is 40 characters"
  ,"El nombre del archivo es inválido, los caracteres permitidos son: _ - y espacios en blanco": "The file name is invalid. Allowed characters are: _ - and spaces"
  ,"País": "Country"
  ,"Cambiar país": "Change country"
  ,"Versión": "Version"
  ,"Síguenos en nuestras redes sociales": "Follow us on social media"
  ,"Conéctate con SOMIT a través de nuestras redes sociales": "Connect with SOMIT through our social media channels"
};

const REGLAS_EN = [
  [/\bReclamos\b/gi, "Claims"], [/\bReclamo\b/gi, "Claim"],
  [/\bAutorizaciones\b/gi, "Authorizations"], [/\bAutorización\b/gi, "Authorization"],
  [/\bLiquidación\b/gi, "Settlement"], [/\bPóliza\b/gi, "Policy"],
  [/\bIngresados\b/gi, "Submitted"], [/\bIngresado\b/gi, "Submitted"],
  [/\bEn proceso\b/gi, "In progress"], [/\bProceso\b/gi, "Process"],
  [/\bAprobado\b/gi, "Approved"], [/\bRechazado\b/gi, "Rejected"],
  [/\bCerrado\b/gi, "Closed"], [/\bAnulado\b/gi, "Cancelled"],
  [/\bPendiente\b/gi, "Pending"], [/\bDocumentos\b/gi, "Documents"],
  [/\bDocumento\b/gi, "Document"], [/\bArchivos\b/gi, "Files"],
  [/\bArchivo\b/gi, "File"], [/\bFecha\b/gi, "Date"],
  [/\bNombre\b/gi, "Name"], [/\bParentesco\b/gi, "Relationship"],
  [/\bDescripción\b/gi, "Description"], [/\bComentarios\b/gi, "Comments"],
  [/\bBuscar\b/gi, "Search"], [/\bGuardar\b/gi, "Save"],
  [/\bSiguiente\b/gi, "Next"], [/\bAnterior\b/gi, "Previous"],
  [/\bRegresar\b/gi, "Back"], [/\bIngresar\b/gi, "Sign in"],
  [/\bInicio\b/gi, "Home"], [/\bAcciones\b/gi, "Actions"],
  [/\bCancelar\b/gi, "Cancel"], [/\bContinuar\b/gi, "Continue"],
  [/\bregistros\b/gi, "records"], [/\bDetalle\b/gi, "Details"],
  [/\bGesti[oó]n\b/gi, "Request"], [/\bP[oó]liza\b/gi, "Policy"],
  [/\bAsegurado\b/gi, "Insured"], [/\bCertificado\b/gi, "Certificate"],
  [/\bDependiente\b/gi, "Dependent"], [/\bDiagn[oó]stico\b/gi, "Diagnosis"],
  [/\bEnfermedad\b/gi, "Condition"], [/\bAsesor\b/gi, "Representative"],
  [/\bTel[eé]fono\b/gi, "Phone"], [/\bMostrar\b/gi, "Show"],
  [/\bGr[aá]fica\b/gi, "Chart"], [/\bPrimera\b/gi, "First"],
  [/\b[ÚU]ltima\b/gi, "Last"], [/\bN[uú]mero\b/gi, "Number"],
  [/\bA[nñ]adidos?\b/gi, "Added"], [/\bObservaci[oó]n\b/gi, "Note"],
  [/\bSeguimiento\b/gi, "Follow-up"], [/\bLiquidaci[oó]n\b/gi, "Settlement"]
];

const INDICIOS_ESPANOL = /\b(el|la|los|las|de|del|que|para|por|con|sin|una?|unos?|se|su|sus|me|mi|tiene|necesito|ingreso|cierre|examen(?:es)?|medicamentos?|autorizaci[oó]n)\b|[¿¡áéíóúñ]/i;

export function pareceTextoEnEspanol(texto) {
  return typeof texto === 'string' && INDICIOS_ESPANOL.test(texto);
}

export function traducirTexto(texto, idioma) {
  if (idioma !== 'en' || typeof texto !== 'string' || !texto.trim()) return texto;
  const inicio = texto.match(/^\s*/)[0];
  const fin = texto.match(/\s*$/)[0];
  const limpio = texto.trim();
  let traducido = TRADUCCIONES_EN[limpio];
  if (!traducido) traducido = REGLAS_EN.reduce((valor, [patron, cambio]) => valor.replace(patron, cambio), limpio);
  return inicio + traducido + fin;
}
